import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { getReport, normTarga } from "@/lib/api";
import ReportView from "@/components/ReportView";
import Paywall from "@/components/Paywall";

export default function Report() {
  const { targa } = useParams();
  const t = normTarga(targa);
  const [state, setState] = useState({ loading: true, report: null, locked: false });

  useEffect(() => {
    let active = true;
    setState({ loading: true, report: null, locked: false });
    getReport(t)
      .then((r) => active && setState({ loading: false, report: r, locked: false }))
      .catch((e) => active && setState({ loading: false, report: null, locked: e?.response?.status === 403 }));
    return () => {
      active = false;
    };
  }, [t]);

  if (state.loading) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center">
        <Loader2 size={36} className="animate-spin text-[#ff007f]" data-testid="report-loading-spinner" />
      </div>
    );
  }

  if (state.locked) {
    return (
      <div className="max-w-[600px] mx-auto px-5 pt-28 pb-20 space-y-6">
        <Link to="/" className="flex items-center gap-2 font-jetmono text-[11px] tracking-[0.2em] text-[#8a8a9e] no-underline hover:text-[#00f0ff] transition-colors" data-testid="report-back-link">
          <ArrowLeft size={14} /> NUOVA RICERCA
        </Link>
        <h1 className="font-orbitron font-black text-2xl tracking-wide uppercase">
          REPORT <span className="text-[#ff007f]">BLOCCATO</span>
        </h1>
        <p className="text-sm text-[#8a8a9e]">
          Il report tecnico per la targa <span className="font-orbitron text-[#00f0ff]">{t}</span> non è ancora
          stato sbloccato su questo dispositivo.
        </p>
        <Paywall targa={t} unlocked={false} />
      </div>
    );
  }

  return <ReportView report={state.report} />;
}
